export default __webpack_public_path__ + "static/media/Nav-Chat.783c019f.svg";